module.exports = __webpack_public_path__ + "img/zhangmen-propa.b7bd8db7.png";